import type { InsuranceProduct } from 'src/interfaces/insuranceProduct'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getInsuranceProducts = (state: State): InsuranceProduct[] => {
  return state.insuranceProduct.insuranceProducts
}

export const getInsuranceProductsLoading = (state: State): boolean => {
  return state.insuranceProduct.insuranceProductsLoading
}

export const getInsuranceProductsError = (state: State): string | null => {
  return state.insuranceProduct.insuranceProductsError
}

export const getInsuranceProductSaving = (state: State): boolean => {
  return state.insuranceProduct.saving
}

export const getInsuranceProductDeletingId = (state: State): string | null => {
  return state.insuranceProduct.deletingId
}
